export default [
    {
        path: 'acolhimento/unidades',
        component: require('./ReadUnidade').default,
        meta: {
            middleware: 'auth', controller: 'AcolhimentoController'
        }
    }, {
        path: 'acolhimentos/idoso/:id',
        component: require('./idoso/Read').default,
        meta: {
            middleware: 'auth', controller: 'AcolhimentoController'
        }
    },
    {
        path: 'acolhimento/idoso/edit/:id',
        component: require('./idoso/Edit').default,
        meta: {
            middleware: 'auth', controller: 'AcolhimentoController'
        }
    },
    {
        path: 'acolhimento/idoso/show/:id',
        component: require('./includes/abasIdoso/Show').default,
        meta: {
            middleware: 'auth', controller: 'AcolhimentoController'
        }
    },
    {
        path: 'acolhimentos/:id',
        component: require('./crianca/Read').default,
        meta: {
            middleware: 'auth', controller: 'AcolhimentoController'
        }
    },
    {
        path: 'acolhimento/edit/:id',
        component: require('./crianca/Edit').default,
        meta: {
            middleware: 'auth', controller: 'AcolhimentoController'
        }
    },
    {
        path: "acolhimento/gestao-vagas",
        name: "GestaoVagas",
        component: require('./GestaoVaga').default,
        meta: {
            middleware: 'auth'
        },
    },
    {
        path: "acolhimento/add-acolhimento",
        name: "AddAcolhimento",
        component: require('./AddAcolhimento').default,
        meta: {
            middleware: 'auth'
        },
    },
    {
        path: "acolhimento/idoso/atividades/:id",
        name: "ShowAtividade",
        component: require('./includes/abasIdoso/ShowAtividade.vue').default,
        props: true,
        meta: {
            middleware: 'auth', controller: 'AcolhimentoGeralController'
        },
    },
    {
        path: "acolhimento/idoso/atividades/edit/:id",
        name: "EditAtividade",
        component: require('./includes/abasIdoso/EditAtividade.vue').default,
        props: true,
        meta: {
            middleware: 'auth', controller: 'AcolhimentoGeralController'
        },
    },
    {
        path: "acolhimento/gestao-vagas/:id",
        name: "GestaoVagasVisualizar",
        component: require('./GestaoVagasVisualizar.vue').default,
        props: true,
        meta: {
            middleware: 'auth', controller: 'AcolhimentoController'
        },
    },
    {
        path: 'acolhimento/show/:id',
        component: require('./includes/abas/Show').default,
        meta: {
            middleware: 'auth', controller: 'AcolhimentoController'
        }
    },
    {
        path: 'familia/acolhimentos/:id',
        component: require('./Read').default,
        meta: {
            middleware: 'auth', controller: 'AcolhimentoController'
        }
    },
    {
        path: 'familia/acolhimentos/edit/:id',
        component: require('./Edit').default,
        meta: {
            middleware: 'auth', controller: 'AcolhimentoController'
        }
    },
    {
        path: 'familia/acolhimentos/show/:id',
        component: require('./Show').default,
        meta: {
            middleware: 'auth', controller: 'AcolhimentoController'
        }
    },

    {
        path: 'acolhimento/crianca/atividades/:id',
        name: 'acolhimento.crianca.atividades.imprimir',
        component: require('./includes/abas/ImprimirAtividadeCrianca.vue').default,
        meta: {
            middleware: 'auth',
            controller: 'AcolhimentoController'
        }
    },

    

    {
        path: 'relatorios/acolhimentos',
        component: require('./reports/Reports').default,
        redirect: 'relatorios/acolhimentos/home',
        meta: { middleware: 'auth', controller: 'RelatorioAcolhimentoController' },
        children: [{
            path: 'home',
            name: "relatorios_home_acolhimentos",
            component: require('./reports/includes/Home').default,
            meta: { middleware: 'auth', controller: 'RelatorioAcolhimentoController' },
        },
        {
            path: 'graficos',
            name: 'graficos_acolhimentos',
            component: require('./reports/includes/Graficos').default,
            meta: { middleware: 'auth', controller: 'RelatorioAcolhimentoController' },
        },
        {
            path: 'crianca/home',
            name: "relatorios_acolhimentos_criancas",
            component: require('./reports/includes/crianca/Home').default,
            meta: { middleware: 'auth', controller: 'RelatorioAcolhimentoController' },
        },
        {
            path: 'crianca/graficos',
            name: 'graficos_acolhimentos_criancas',
            component: require('./reports/includes/crianca/Graficos').default,
            meta: { middleware: 'auth', controller: 'RelatorioAcolhimentoController' },
        },
        {
            path: 'idoso/home',
            name: 'relatorios_acolhimentos_idosos',
            component: require('./reports/includes/idoso/Home').default,
            meta: { middleware: 'auth', controller: 'RelatorioAcolhimentoController' },
        },
        {
            path: 'idoso/graficos',
            name: 'graficos_acolhimentos_idosos',
            component: require('./reports/includes/idoso/Graficos').default,
            meta: { middleware: 'auth', controller: 'RelatorioAcolhimentoController' },
        },
        {
            path: 'geral/home',
            name: 'relatorios_acolhimentos_geral',
            component: require('./reports/includes/geral/Home').default,
            meta: {
                middleware: 'auth',
                controller: 'RelatorioAcolhimentoController'
            },
        },
        {
            path: 'geral/graficos',
            name: 'graficos_acolhimentos_geral',
            component: require('./reports/includes/geral/Graficos').default,
            meta: {
                middleware: 'auth',
                controller: 'RelatorioAcolhimentoController'
            },
        },
        ]
    },


]
